import API from "../api";
import store from "./Store";
import { DOMAIN_NAME } from '../config/default.js';

export const getSortedByPortalVirtualAccounts = (accounts) => {
    const vAccounts = Array.isArray(accounts) ? accounts : [];
    const entityRefs = {};
    const parentRefs = {};
    // todo - Unused object that should be used after a refacto to improve perfomances.
    const allRefs = {};

    const vAccountsDomains = vAccounts.reduce((memo, va) => {
        allRefs[va.entityId] = va;

        if (va.parentEntityId) { // subEntity
            if (!parentRefs[va.parentEntityId]) {
                parentRefs[va.parentEntityId] = [];
            }
            parentRefs[va.parentEntityId].push(va);
            return memo;
        } 
        // mainEntity
        // set children array to legalEntity using reference so it's always updated.
        if (!parentRefs[va.entityId]) {
            va.children = parentRefs[va.entityId] ? parentRefs[va.entityId] : [];
            parentRefs[va.entityId] = va.children;
        }

        if (!memo[va.companyDomain]) {
            memo[va.companyDomain] = [];
        }
        memo[va.companyDomain].push(va);
        return memo;
    }, {});

    return vAccountsDomains;
};


export const getUserProfile = () => API.Session.getUserProfile();
export const getUserVirtualAccountsWithPermissions = () => API.Session.getMyVirtualAccountsWithPermissions();
export const getUserData = async () => {
    const [profileRes, vAccountsRes] = await Promise.allSettled([getUserProfile(), getUserVirtualAccountsWithPermissions()]);
    if (profileRes.status !== 'fulfilled')
        throw new Error("cannot get user profile");
    if (vAccountsRes.status !== 'fulfilled')
        throw new Error("cannot get user virtual accounts");

    const profile = profileRes.value?.data;
    const userVAccounts = getSortedByPortalVirtualAccounts(vAccountsRes.value?.data);

    // sort vAccounts.
    profile._vAccounts = userVAccounts[DOMAIN_NAME] ? userVAccounts[DOMAIN_NAME] : [];
    profile._othersVAccounts = {[DOMAIN_NAME]: [], ...userVAccounts};
    delete profile._othersVAccounts[DOMAIN_NAME];

    return profile;
};

export const syncDrivePermissionsForEntity = async () => {
    await API.Drive.syncEntityDrivePermission();
};

export const getMyPortalSubVirtualAccounts = (profile, entityId) => {
    let subAccs = [];
    if (profile && Array.isArray(profile._vAccounts)) {
        subAccs = profile._vAccounts.reduce((memo, vAcc) => {
            if (vAcc && vAcc.children && Array.isArray(vAcc.children))
                vAcc.children.forEach((child) => {memo.push(child)});
        }, []);
    }
    return subAccs;
};

export const getCurrentVAccount = (profile, session) => {
    if (!profile) return null;
    let currentVirtualAccount = session?.currentVirtualAccount;

    if (!currentVirtualAccount && profile._vAccounts.length > 0) {
        currentVirtualAccount = profile._vAccounts[0]?.entityId;
    }

    const va = profile._vAccounts.find(acc => acc.entityId === currentVirtualAccount);
    return va;
};

export const getCurrentSubVAccount = (profile, session) => {
    if (!profile) return null;
    let currentVirtualAccount = session?.currentVirtualAccount;

    if (!currentVirtualAccount && profile._vAccounts.length > 0) {
        currentVirtualAccount = profile._vAccounts[0]?.entityId;
    }

    const parentEntity = profile._vAccounts.find(acc => acc.entityId === currentVirtualAccount);
    const va = parentEntity?.children.find(subAcc => subAcc.parentEntityId === currentVirtualAccount);
    return va;
};

export const getCurrentSubVAccounts = (profile, session) => {
    const currentVA = getCurrentVAccount(profile, session);
    return (currentVA.children || []);
}
